export const normalizeFieldOrder = (raw, fallback = []) => {
  const fallbackOrder = Array.isArray(fallback) ? fallback : [];

  const normalizeValue = (value) => {
    if (value == null) return [];
    if (Array.isArray(value)) return value.filter(Boolean).map(String);

    if (typeof value === "string") {
      const trimmed = value.trim();
      if (!trimmed) return fallbackOrder;

      try {
        return normalizeValue(JSON.parse(trimmed));
      } catch {
        return fallbackOrder;
      }
    }

    if (typeof value === "object") {
      const entries = Object.entries(value);
      if (!entries.length) return fallbackOrder;

      const values = entries.map(([, entryValue]) => entryValue);

      if (values.every((entryValue) => typeof entryValue === "string" || typeof entryValue === "number")) {
        return values.map(String).filter(Boolean);
      }

      if (values.every((entryValue) => entryValue && typeof entryValue === "object")) {
        return values
          .map((entryValue) =>
            entryValue.key ||
            entryValue.field_key ||
            entryValue.fieldKey ||
            entryValue.property_key ||
            entryValue.name ||
            entryValue.value
          )
          .filter(Boolean)
          .map(String);
      }

      return entries.map(([key]) => key).filter(Boolean);
    }

    return fallbackOrder;
  };

  const normalized = normalizeValue(raw);
  return normalized.length ? normalized : fallbackOrder;
};
